/**
 * The class strings every moving or focusable surface shares, so that one
 * curve and one focus language run through the whole app rather than being
 * re-typed per component.
 */

/** The opening curve. Everything that moves on a press moves on this. */
export const panelMotion = "transition-all duration-200 ease-[cubic-bezier(0.16,1,0.3,1)]";

/** A press compresses; it does not sink. */
export const press = "active:scale-[0.97]";

/** A halo with breathing room, never a hard ring. */
export const focusHalo =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/25 focus-visible:ring-offset-2 focus-visible:ring-offset-background";

/** The same halo, flush, for controls already inside a framed container. */
export const focusHaloFlush =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/25";

export const ghostButton = `h-9 rounded-full px-4 text-sm font-medium text-muted-foreground hover:bg-foreground/5 hover:text-foreground ${panelMotion} ${press} ${focusHalo}`;

/**
 * One line inside a `panelCard`, reporting something rather than offering it.
 * Its radius plus the card's padding comes to the card's own radius, so the
 * corners stay concentric.
 */
export const panelRowQuiet =
  "flex h-9 w-full items-center gap-2.5 rounded-lg px-2.5 text-left text-sm";

/** The same line, for one that can be pressed, and so holds a `HapticSurface`. */
export const panelRow = `${panelRowQuiet} relative hover:bg-foreground/10 ${panelMotion} ${focusHaloFlush}`;
